// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapButton, BootstrapIcon } from '../../../../dsl/front';
/**
 * @author Sebastian Dziechciarz
 */
let ShareButton = class ShareButton extends Vue {
    constructor() {
        super(...arguments);
        this.actionIcon = '';
    }
    created() {
        this.actionIcon = this.icon;
    }
    /**
     * Handles `@click` event on the `<button>`.
     */
    onClick() {
        this.callback();
        if (this.clickedIcon) {
            this.actionIcon = this.clickedIcon;
            setTimeout(() => {
                this.actionIcon = this.icon;
            }, 2000);
        }
    }
};
__decorate([
    Prop({
        type: Function,
        required: true
    })
], ShareButton.prototype, "callback", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: ''
    })
], ShareButton.prototype, "icon", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: ''
    })
], ShareButton.prototype, "clickedIcon", void 0);
__decorate([
    Prop({
        type: String,
        required: true
    })
], ShareButton.prototype, "label", void 0);
__decorate([
    Prop({
        type: Number,
        required: false
    })
], ShareButton.prototype, "count", void 0);
ShareButton = __decorate([
    Component({
        name: 'ShareButton',
        components: {
            BootstrapButton,
            BootstrapIcon
        },
        template: `
    <button class="share-button" @click="onClick">
      <BootstrapIcon :name="actionIcon" size="small" class="share-button__icon"
                     :class="{'text-success':(actionIcon==='checkmark')}" :alt="label" />
      {{ count }}
    </button>
  `
    })
], ShareButton);
export { ShareButton };
export default ShareButton;
